import { render } from "./Login.vue?vue&type=template&id=2ef7d778&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=2ef7d778&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef7d778"]])

export default __exports__